import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			movieList: {
				title: "Movies",
				searchLabel: "Title, UUID or SofaDB ID",
				headerTitle: "Title",
				headerYear: "Year",
				headerState: "Brands",
				headerCreatedAt: "Created",
				dpEdit: "Edit",
				dpAny: "All",
				stateEnabled: "Active",
				stateDisabled: "Inactive",
				state: "State",
				stateBrands: "Brands"
			},
			movies: {
				posterImage: "Poster",
				mainImage: "Image",
				imageGallery: "Gallery",
				title: "Title",
				originalTitle: "Original Title",
				theatricalReleaseDate: "Theatrical Release Date",
				productionYear: "Year",
				country: "Country",
				runtimeMinutes: "Runtime (min)",
				fsk: "FSK",
				printGenre: "Print Genre",
				crew: "Crew",
				ratings: {
					title: "Rating",
					text: "Verdict",
					humor: "Humor",
					demand: "Demand",
					action: "Action",
					suspense: "Suspense",
					eroticism: "Eroticism",
					imdb: "IMDB"
				},
				brands: {
					ratingTotal: "Total Rating",
					isEnabled: "Enabled",
					toMoviePage: "To Movie Page"
				},
				reviewTitle: "Content",
				reviewKicker: "Lead Text",
				reviewContent: "Description",
				router: { movieDetails: "Details" }
			}
		},
		de: {
			movieList: {
				title: "Filme",
				searchLabel: "Titel, UUID oder SofaDB ID",
				headerTitle: "Titel",
				headerYear: "Jahr",
				headerState: "Marken",
				headerCreatedAt: "Erstellt",
				dpEdit: "Bearbeiten",
				dpAny: "Beliebig",
				stateEnabled: "Aktiv",
				stateDisabled: "Inaktiv",
				state: "Status",
				stateBrands: "Marken"
			},
			movies: {
				posterImage: "Poster",
				mainImage: "Bild",
				imageGallery: "Galerie",
				title: "Titel",
				originalTitle: "Originaltitel",
				theatricalReleaseDate: "Kinostart",
				productionYear: "Jahr",
				country: "Land",
				runtimeMinutes: "Länge (min)",
				fsk: "FSK",
				printGenre: "Printgenre",
				crew: "Crew",
				ratings: {
					title: "Bewertung",
					text: "Fazit",
					humor: "Humor",
					demand: "Anspruch",
					action: "Action",
					suspense: "Spannung",
					eroticism: "Erotik",
					imdb: "IMDB"
				},
				brands: {
					ratingTotal: "Gesamtbewertung",
					isEnabled: "Aktiv",
					toMoviePage: "Zur Filmseite"
				},
				reviewTitle: "Inhalt",
				reviewKicker: "Vorzeile",
				reviewContent: "Beschreibung",
				router: { movieDetails: "Details" }
			}
		}
	},
	routes: [{
		path: "/movies",
		children: [{
			path: "",
			name: "movie_list",
			component: () => import("./movie-list.view-CLlxcTU1.js"),
			meta: { requiredRight: "movies:navigate" }
		}, {
			path: ":id",
			name: "movie_detail",
			component: () => import("./movie-edit.view-Poy0I11O.js"),
			props: (t) => ({
				title: e().t("movies.router.movieDetails"),
				id: t.params.id,
				backRoute: "/movies"
			}),
			meta: { requiredRight: ["movies:navigate"] }
		}]
	}]
};
//#endregion
export { t as movieModule };

//# sourceMappingURL=index.es.js.map